import dayjs from "dayjs";
import "dayjs/locale/nl";

dayjs.locale("nl");

// Formats an ISO date-time as e.g. "dinsdag 15 juli 2026 om 09:00".
export const formatAppointmentDateTime = (
  isoDateTime: unknown,
): string | undefined => {
  if (typeof isoDateTime !== "string" || isoDateTime === "") return undefined;

  const parsed = dayjs(isoDateTime);
  if (!parsed.isValid()) return undefined;

  return `${parsed.format("dddd D MMMM YYYY")} om ${parsed.format("HH:mm")}`;
};
